export const LOGIN = '/login'
export const SIGN_UP = '/signup'
export const FORGOT_PASSWORD = '/forgot-password'
export const RESET_PASSWORD = '/reset-password/:meta'
export const QR_DETAILS = '/qr-details'

export const HOME = '/'
